module.exports = __webpack_public_path__ + "img/capa.efdb0d58.png";